import {RequestsRecord} from '../../../../../common/interfaces/IHttpRequest';

export const Requests: RequestsRecord = {
  getVehicleGroupsWithBodyTypes: {
    url: '/PV/Settings/VehicleGroupsWithBodyTypes',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
  },

  getUsageTypes: {
    url: '/CRE/Settings/UsageTypes',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
  },

  getObjectTypes: {
    url: '/CRE/Settings/ObjectTypes',
    authType: 'hmac',
    method: 'GET',
    errorType: 'popup',
  },
};
